import React from "react";
import isValidPrice from "../../utils/isValidPrice";
import Spinner from "../Spinner/Spinner";

const getGstTypeDisplayValue = () => {
      return "inc. gst";
};

const getPriceDisplayValue = price => {
  const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  return isValidPrice(price)
    ? Number(price).toLocaleString("en-AU", options)
    : price;
};

const ClearancePriceDisplay = ({price, priceLoading, error}) => {
  if (priceLoading) {
    return <Spinner size="18px" />;
  }
  if (error || !price) {
      return  (<div></div>)
  }

  return (
    <div className="pdp-prices-block__price pdp-prices-block__price--clearance">
      <span id="pdp-product-price" className="pdp-prices-block__price-val js-pdp__price-val" >
        {getPriceDisplayValue(price)}
      </span>
      <span className="pdp-prices-block__gst-mark js-pdp__gst-mark">
        {getGstTypeDisplayValue()}
      </span>
    </div>
);
};

export default ClearancePriceDisplay;
